import React from 'react';
import Highlight from '../../components/Highlight';
import variables from '../../styles/variables.module.scss';
import img1 from '../../assets/frames/mevia-extraimg1@2x-min.png';
import img2 from '../../assets/frames/mevia-extraimg2@2x-min.png';
import img3 from '../../assets/frames/mevia-extraimg3@2x-min.png';

import hero from '../../assets/hero/mevia-hero-min.jpg';
import env1 from '../../assets/envImages/mevia-env1@2x-min.png';
import env2 from '../../assets/envImages/mevia-env2@2x-min.png';
import footerBanner from '../../assets/envImages/mevia-footerBanner-min.jpg';

export default {
  path: '/cases/mevia',
  color: variables.mevia,
  hero: { fall: hero },
  xtra: [
    { fall: img1 },
    { fall: img2 },
    { fall: img3 },
  ],
  environments: { env1, env2 },
  footerBanner: { fall: footerBanner },
  // quoteData: {
  //   quote: '.',
  //   name: 'Erik Jesper Hassel',
  //   profession: 'CEO, Mevia AB',
  // },
  title: 'Mevia',
  sideHeadingFirst: 'iOS & Android application',
  sideHeadingSecond: 'Developed in React Native',
  infoTitle: 'What we built',
  infoBody:
  <span>
    We App helped Mevia develop a mobile app that incorporated Mevia’s medical adherence solutions. And helped digitalize processes that were to a large extent carried out through SMS notifications or phone calls.
    <br />
    <br />
    The app was built in
    {' '}
    <Highlight>React Native</Highlight>
.
  </span>,
  infoData: {
    Scope: ['Scope', 'Project management', 'User experience', 'UI & UX design'],
    Deliverables: ['Deliverables', 'iOS development', 'Android development', 'Cross-platform', 'Software development'],
    Goal: ['Goal', 'Project management', 'User experience', 'UI & UX design', 'Maintanance/support'],
  },
  titleBodyData: {
    0: {
      title: 'Mevia helps solve the issue of medication errors and missed doses',
      body: 'Mevia is a startup developed at Chalmers University of Technology, aimed to assist with medicine adherence solutions for both humans and animals. Mevia helps patients, or caretakers, manage treatments. As such, their solutions help inform when to take a dose or buy a refill. As well as improve adherence by providing treatment information and communication between patient and doctor/vet.',
    },
  },
};
